"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _FavoritesHeart = require("./FavoritesHeart");
Object.keys(_FavoritesHeart).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _FavoritesHeart[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _FavoritesHeart[key];
    }
  });
});
var _FavoritesHeartIconButton = require("./FavoritesHeartIconButton");
Object.keys(_FavoritesHeartIconButton).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _FavoritesHeartIconButton[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _FavoritesHeartIconButton[key];
    }
  });
});
//# sourceMappingURL=index.js.map